import {ReportLegendColorsEnum} from 'common/proxies/enum-proxy';

const colorScales = {
  [ReportLegendColorsEnum.BLUE_RED.id]: [
    'rgb(103, 169, 207)',
    'rgb(209, 229, 240)',
    'rgb(253, 219, 199)',
    'rgb(239, 138,  98)',
    'rgb(178,  24,  43)',
  ],
  [ReportLegendColorsEnum.GREEN_YELLOW_RED.id]: [
    'rgb(68, 163, 55)',
    'rgb(209, 209,  13)',
    'rgb(209, 140,  13)',
    'rgb(209,  75,  13)',
    'rgb(209,  32,  13)',
  ],
  [ReportLegendColorsEnum.RED_BLUE.id]: [
    'rgb(178,  24,  43)',
    'rgb(239, 138,  98)',
    'rgb(253, 219, 199)',
    'rgb(209, 229, 240)',
    'rgb(103, 169, 207)',
  ],
  [ReportLegendColorsEnum.RED_YELLOW_GREEN.id]: [
    'rgb(209,  32,  13)',
    'rgb(209,  75,  13)',
    'rgb(209, 140,  13)',
    'rgb(209, 209,  13)',
    'rgb(68, 163, 55)',
  ],
};

export const DEFAULT_COLOR_SCALE = Object.values(colorScales)[0];
export default colorScales;
